<template>
  <page-template>
    <template #title>
      <div
        class="d-flex align-center justify-start pa-8"
      >
        <page-title
          :title="pageTitle"
          :back-to="navigateBackRoute"
        />
      </div>
    </template>
    <template #content>
      <v-row>
        <v-col cols="12">
          <v-container
            class="py-0"
            fluid
            grid-list-xl
          >
            <v-row>
              <v-col cols="12">
                <v-card>
                  <v-tabs v-model="tabs">
                    <v-tab>Perfil</v-tab>
                    <v-tab
                      v-for="(system, idx) in userSystems"
                      :key="makeKeyName('tab', system.value, idx)"
                    >
                      {{ system.text }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tabs">
                    <v-tab-item>
                      <user-profile-form
                        v-model="payload"
                        :loading="loading"
                      />
                    </v-tab-item>
                    <v-tab-item
                      v-for="(system, idx) in userSystems"
                      :key="makeKeyName('tab_item', system.value, idx)"
                    >
                      <component
                        :is="system.component"
                        v-model="payload"
                        :loading="loading"
                        :user-system="system.user"
                      />
                    </v-tab-item>
                  </v-tabs-items>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </template>
  </page-template>
</template>

<script>
import PageTemplate from 'Arch/template/PageTemplate.vue';
import PageTitle from 'Arch/template/PageTitle.vue';
import UsersRequest from 'App/users/UsersRequest';
import ServiceMixin from 'Arch/mixins/ServiceMixin';
import UserProfileForm from 'App/users/components/forms/UserProfileForm.vue';
import userSystemsEnum from 'Arch/enums/userSystems';
import ContaCardDisplay from 'App/users/components/display/ContaCardDisplay.vue';

export default {
  name: 'UserForm',
  components: {
    PageTemplate,
    PageTitle,
    UserProfileForm,
    ContaCardDisplay,
  },
  mixins: [ServiceMixin],
  data: () => ({
    pageTitle: 'Detalhes do usuário',
    navigateBackRoute: 'users.list',
    requestClass: UsersRequest,
    loading: false,
    tabs: null,
    config: {
      errorMessage: 'Falha ao buscar informações do usuário',
      showSuccessSwal: false,
    },
    payload: {
      dateOfBirth: '',
      mothersName: '',
      address: {
        postalCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      contacts: [
        {
          type: '',
          cellPhone: '',
          email: '',
          statusEmail: '',
        },
      ],
      username: '',
      name: '',
      userSystems: [
        {
          isSessionActive: '',
          userId: '',
          system: '',
          deviceId: '',
          pushNotificationToken: '',
          status: '',
          lastLogin: '',
          username: '',
          completeName: '',
          dateOfBirth: '',
          email: '',
          cellPhone: '',
          id: '',
          createdAt: '',
          updatedAt: '',
          isActive: '',
        },
      ],
      id: '',
      createdAt: '',
      updatedAt: '',
      isActive: '',
    },
    systems: userSystemsEnum,
  }),
  computed: {
    userId() {
      return this.$route.params.id;
    },
    userSystems() {
      return this.payload.userSystems.map(
        (user) => {
          const system = this.systems.find(
            (s) => s.value === user.system,
          );
          if (system) {
            return {
              ...system,
              component: `${system.value}Display`,
              user,
            };
          }
          return {
            text: user.system,
            component: '',
            user,
          };
        },
      );
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(id) {
        if (Number(id) >= 1) {
          this.getData();
        }
      },
    },
  },
  methods: {
    getData() {
      this.handleLoading();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.requestClass.get(
          this.userId,
        ),
        this.config,
        this.handlePayload,
      );
    },
    handlePayload(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.payload = this.overrideNullProperties(
          response.data,
          this.payload,
        );
      }
    },
    makeKeyName(key, ...rest) {
      let name = `key_${key}`;
      rest.forEach(
        (item) => {
          name += `_${item}`;
        },
      );
      return name;
    },
  },
  provide() {
    return {
      makeKeyName: this.makeKeyName,
      reloadProfilePage: this.getData,
    };
  },
};
</script>
